export default __webpack_public_path__ + "static/media/3.fca581b3.png";